import { render, staticRenderFns } from "./RegionDetails.vue?vue&type=template&id=550a7baa&"
import script from "./RegionDetails.vue?vue&type=script&lang=js&"
export * from "./RegionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports